import { enableProdMode, Injector } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { defineCustomElements } from '@flowww/apps-design-system/loader/index.es2017';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

/** Registra los web components del design system */
defineCustomElements();

if (environment.production) {
  enableProdMode();
}

export let appInjector: Injector;
platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .then((componentRef) => {
    appInjector = componentRef.injector;
  })
  .catch((err) => console.log(err));
